/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AddressApiModel } from './addressApiModel';


export interface CategorizationProviderApiModel { 
    providerId: number;
    name: string;
    ico: string;
    alias: string;
    active: boolean;
    addressDto: AddressApiModel;
}

